// extracted by mini-css-extract-plugin
export var changeIcon = "_4r-4";
export var container = "_4r-0";
export var divider = "_4r-7";
export var externalLinkIcon = "_4r-1";
export var green = "_4r-5";
export var helpCircleIcon = "_4r-3";
export var iconButton = "_4r-2";
export var red = "_4r-6";